import React from 'react';
import { PagePath, RowHeaderTable, TableVehicleTypes } from '../../components';

const VehicleTypes: React.FC = () => {
  return (
    <div>
      <div className="container-body no-padding">
        <RowHeaderTable
          name="Tipos de Veículos"
          navigationPath="/home/vehicle-types/create"
        />
        <TableVehicleTypes />
      </div>
    </div>
  );
};

export default VehicleTypes;
